<template lang="pug">
h3.text-danger(v-if="error") {{ error }}
.container-fluid.text-left(v-else-if="tarea")
	.card.card-primary
		.card-header.bg-info.text-white
			|Información básica
			button.close(type="button" aria-label="Close" @click="cerrar")
				span(aria-hidden="true") &times;
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3.mb-2
					span.fa.fa-info-circle(style="position:relative;float:left;margin-right:10px;vertical-align:top;font-size:5em;display:inline-block;opacity:0.1")
					b {{tarea.produccion.anunciante.nombre}}
					br
					|{{tarea.produccion.titulo}}
					br
					span.text-muted
						|{{tarea.titulo}}
				.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3.mb-2
					img.rounded-circle(:src="tarea.produccion.usuario.avatar" width="50" style="float:left;position:relative;display:inline-block;vertical-align:top;margin-right:10px;")
					b {{tarea.produccion.usuario.nombre}}
					br
					span.text-muted Creada el {{tarea.fecha_creacion}}
				.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3.mb-2
					b Soportes
					br
					.badge.bg-warning.text-dark.p-1.mr-1.mb-1(v-for="soporte in tarea.soportes" :key="soporte.ID_soporte") {{ soporte.nombre }}
				.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3.mb-2
					b Detalles
					br
					|Tipo: 
					b
						span(v-if="tarea.tipo === 'cuna'") Cuña
					br
					|Fecha de inicio: <b>{{tarea.fecha_inicio / 1000 | moment('DD-MM-YYYY')}}</b>
					br
					|Fecha de fin: <b>{{tarea.fecha_fin  / 1000 | moment('DD-MM-YYYY')}}</b>
					br
					span(v-if="tarea.duracion") Duración: <b>{{tarea.duracion}} segundos</b>
		.card-body.bg-light
			.row
				.col
					button.btn.btn-sm.btn-success.mr-1(title="Información del proceso" @click="verHistorial = tarea.ID_tarea")
						span.fa.fa-info-circle
					button.btn.btn-sm.btn-info.mr-1(:title="'Hay ' + tarea.versiones.length + ' version(es)'" @click="listadoVersiones = true")
						span.fa.fa-history(style="margin-right:3px;")
						|{{tarea.versiones.length}}
					button.btn.btn-sm.btn-dark.mr-1(v-if="tarea.esAgente || permisos.produccion_crearTodos" @click="editarProduccion()" title="Editar producción")
						span.fa.fa-ticket
					button.btn.btn-sm.btn-warning.mr-1(v-if="tarea.esAgente || permisos.produccion_crearTodos" @click="editarTarea = true" title="Editar tarea")
						span.fa.fa-tasks
					button.btn.btn-sm.mr-1(:class="(versionActual.teleprompter) ? 'btn-danger' : 'btn-default'" title="Mandar al teleprompter" @click="setTeleprompter()")
						span.fa.fa-desktop
					button.btn.btn-sm.btn-dark.text-white.mr-1(@click="copiarTexto")
						span.fa.fa-copy.mr-2
						|Copiar texto
				.col.text-center
					span(style="font-weight:bold;font-size:1em;line-height:30px;padding-left:5px !important;padding-right:5px !important;" :class="(esUltima) ? 'badge badge-warning p-0' : 'badge badge-danger p-0'")
						span(v-if="esUltima") {{tituloFase}}
						span(v-if="!esUltima") Versión rechazada
				.col.text-right
					div(v-if="esUltima && esTareaValida")
						div(v-if="tarea.fase !== 'finalizada'")
							button.btn.btn-sm.btn-warning.mr-1(@click="cancelarTarea" v-if="tarea.esAgente || permisos.producciones_cancelarTareasAjenas")
								span.fa.fa-ban.mr-2
								|Cancelar tarea
							button.btn.btn-sm.btn-danger.mr-1(v-if="tarea.fase !== 'pteIdea' && (tarea.esAgente || permisos.produccion_crearTodos)" @click="rechazar()")
								span.fa.fa-trash.mr-2
								|Rechazar
							button.btn.btn-sm.btn-info.mr-1(v-if="tarea.fase === 'pteIdea' && permisos.produccion_crearIdeas" @click="siguienteFase")
								span(:class="iconoSiguienteFase" style="font-size:1.2em; margin-right:3px;")
								|{{ txtSiguienteFase }}
							button.btn.btn-sm.btn-info.mr-1(v-if="tarea.fase === 'pteAprobarIdea' && (tarea.esAgente || permisos.produccion_crearTodos)" @click="siguienteFase")
								span(:class="iconoSiguienteFase" style="font-size:1.2em; margin-right:3px;")
								|{{ txtSiguienteFase }}
							button.btn.btn-sm.btn-info.mr-1(v-if="tarea.fase === 'pteProduccion' && permisos.produccion_subirProducidos" @click="siguienteFase")
								span(:class="iconoSiguienteFase" style="font-size:1.2em; margin-right:3px;")
								|{{ txtSiguienteFase }}
							button.btn.btn-sm.btn-info(v-if="tarea.fase === 'pteAprobarProduccion' && (tarea.esAgente || permisos.produccion_crearTodos)" @click="siguienteFase")
								span(:class="iconoSiguienteFase" style="font-size:1.2em; margin-right:3px;")
								|{{ txtSiguienteFase }}
						div(v-if="tarea.fase === 'finalizada'")
							.btn.btn-success.btn-sm Producción finalizada
	.row.mt-3
		.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-3
			.card.mb-2(v-if="versionAnterior")
				.card-header.bg-danger.text-light
					|Versión anterior rechazada por {{versionAnterior.usuario_rechaza.nombre}}
					.pull-right
						span(:class="(!mostrarRechazo) ? 'fa fa-window-maximize': 'fa fa-window-minimize'" style="cursor:pointer" @click="mostrarRechazo = !mostrarRechazo")
				.card-body(v-if="mostrarRechazo")
					img.rounded-circle.mr-1(:src="versionAnterior.usuario_rechaza.avatar" style="width:60px;position:relative;display:inline-block;float:left;")
					h5.text-info La explicación de {{versionAnterior.usuario_rechaza.nombre}} es:
					p.text-muted.mt-1(v-html="versionAnterior.motivo_rechazo.replace('\\n', '<br>')")
				.card-body.bg-light(v-if="mostrarRechazo && Object.keys(versionAnterior.listado_motivos_rechazo).length > 0")
					h5.text-info Motivos del rechazo
					br
					div(v-if="versionAnterior.listado_motivos_rechazo['cliente']")
						b De parte del cliente
						ul
							li(v-for="motivo in versionAnterior.listado_motivos_rechazo['cliente']" :key="motivo") {{motivo}}
					div(v-if="versionAnterior.listado_motivos_rechazo['agente']")
						b De parte del agente
						ul
							li(v-for="motivo in versionAnterior.listado_motivos_rechazo['agente']" :key="motivo") {{motivo}}
					div(v-if="versionAnterior.listado_motivos_rechazo['marketing']")
						b De parte de márketing
						ul
							li(v-for="motivo in versionAnterior.listado_motivos_rechazo['marketing']" :key="motivo") {{motivo}}
					div(v-if="versionAnterior.listado_motivos_rechazo['tecnico']")
						b De parte de técnica
						ul
							li(v-for="motivo in versionAnterior.listado_motivos_rechazo['tecnico']" :key="motivo") {{motivo}}
			.card.mb-2(v-if="tarea.produccion.descripcion")
				.card-header.bg-light.text-dark
					|Anotaciones de la producción
					.pull-right
						span(:class="(!mostrarAnotacionesProduccion) ? 'fa fa-window-maximize': 'fa fa-window-minimize'" style="cursor:pointer" @click="mostrarAnotacionesProduccion = !mostrarAnotacionesProduccion")
				.card-body(v-if="mostrarAnotacionesProduccion")
					span(v-if="tarea.produccion.descripcion" v-html="tarea.produccion.descripcion.replace('\\n', '<br>')")
			.card.mb-2(v-if="tarea.descripcion")
				.card-header.bg-light.text-dark
					|Anotaciones de esta tarea
					.pull-right
						span(:class="(!mostrarAnotacionesTarea) ? 'fa fa-window-maximize': 'fa fa-window-minimize'" style="cursor:pointer" @click="mostrarAnotacionesTarea = !mostrarAnotacionesTarea")
				.card-body(v-if="mostrarAnotacionesTarea")
					span(v-if="tarea.descripcion" v-html="tarea.descripcion.replace('\\n', '<br>')")
					.text-danger.text-center(v-if="!tarea.descripcion")
						span.fa.fa-ban(style="font-size:2em;")
						br
						|No hay anotaciones
			comentarios(:tarea.sync="tarea")
		.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
			.card
				.card-header(:class="(!tarea.produccion.externa) ? 'bg-info text-white' : 'bg-warning text-dark'")
					.row
						.col.text-left
							|Creatividad
							span(v-if="tarea.produccion.externa") (producción externa)
						.col.text-right
							cronometro(@tiempo="setDuracionEstimada($event)" v-if="permisos.produccion_crearIdeas && tarea.fase === 'pteIdea' && !versionActual.tiempo_estimado")
							span(v-if="versionActual.tiempo_estimado")
								span.fa.fa-clock-o.mr-2
								b Duración estimada: 
								|{{versionActual.tiempo_estimado}} seg.
								button.btn.btn-sm.btn-warning.ml-2(v-if="permisos.produccion_crearIdeas && tarea.fase === 'pteIdea'" @click="versionActual.tiempo_estimado = null")
									span.fa.fa-edit
				.card-body
					.alert.alert-danger.text-center(v-if="!esUltima")
						span.fa.mb-2.fa-exclamation-triangle(style="font-size:3em;")
						h3 Esta no es la última versión
					.alert.alert-warning.text-center(v-if="tarea.express_fecha")
						span.fa.mb-2.fa-star(style="font-size:3em;")
						h3 Esto es una producción express
					.alert.alert-warning.text-center(v-if="versionActual.tiempo_estimado > tarea.duracion")
						span.fa.mb-2.fa-exclamation-triangle(style="font-size:3em;")
						h3 La duración estimada excede el tiempo contratado por {{versionActual.tiempo_estimado - tarea.duracion}} segundos
					.alert.alert-warning.text-center(v-if="!esTareaValida")
						span.mb-2.fa.fa-ban(style="font-size:3em;")
						h3 El agente debe completar los datos requeridos para poder continuar con esta tarea.
						h4 Los datos obligatorios son: Fecha de inicio, fecha de fin y duración
						br
						button.btn.btn-danger(@click="editarTarea = true" v-if="tarea.esAgente || permisos.produccion_crearTodos")
							span.fa.fa-tasks.mr-2
							|Editar tarea
					div(v-if="esTareaValida")
						h6 Locutores requeridos
						alert.alert-info(v-if="tarea.vocesExternas > 0")
							span.fa.fa-info-circle.mr-2
							|Esta producción requiere <b><u>{{tarea.vocesExternas}} voces externas</u></b>
						.row
							tarjeta-locutor.col-xs-6.col-sm-4.col-md-3.col-lg-3.col-xl-3.mb-2(:tarea="tarea"
									:version-actual.sync="versionActual"
									:locutor="locutor"
									v-for="locutor in versionActual.locutores"
									:key="locutor.titulo")
						editor-texto(:focoactivo="focoactivo" v-if="tarea.fase === 'pteIdea' && versionActual && esUltima && permisos.produccion_crearIdeas" :version.sync="versionActual")
						visualiza-texto(:tarea="tarea" :version.sync="versionActual" v-if="(tarea.fase !== 'pteIdea' && versionActual) || !esUltima")
		.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-3
			.card.mb-2(v-if="tarea.produccion.ficheros.length > 0")
				.card-header.bg-success.text-dark
					|Ficheros de apoyo de la producción
				.table-responsive
					table.table.table-striped.mb-0
						tbody
							tr(v-for="fichero in tarea.produccion.ficheros" :key="fichero.ID_fichero" @click="verFichero(fichero, 'orden')" style="cursor:pointer;")
								td {{fichero.nombre}}
			.card.mb-2
				.card-header.bg-warning.text-dark
					|Ficheros de apoyo de la tarea
					button.btn.btn-dark.btn-sm(v-if="tarea.fase !== 'finalizada' && esTareaValida && esUltima && (tarea.esAgente || permisos.produccion_crearTodos)" style="position:absolute;display:block;right:5px;top:6px;" @click="nuevoFichero('apoyo')")
						span.fa.fa-upload
				.table-responsive(v-if="tarea.ficheros.length > 0")
					table.table.table-striped.mb-0
						tbody
							tr(v-for="fichero in tarea.ficheros" :key="fichero.ID_fichero")
								td(@click="verFichero(fichero, 'tarea')" style="cursor:pointer;") {{fichero.nombre}}
			.card.mb-2
				.card-header.bg-danger.text-white
					|Ficheros producidos
					button.btn.btn-dark.btn-sm(v-if="tarea.fase === 'pteProduccion' && esTareaValida && esUltima && permisos.produccion_subirProducidos" style="position:absolute;display:block;right:5px;top:6px;" @click="nuevoFichero('final')")
						span.fa.fa-upload
				.table-responsive(v-if="versionActual.ficheros.length > 0")
					table.table.table-striped.mb-0
						tbody
							tr(v-for="fichero in versionActual.ficheros" :key="fichero.ID_fichero")
								td
									span.fa.fa-copyright(title="Contiene fonográmas protegidos por derechos de autor" style="font-size:2em;margin: 5px;vertical-align:middle;" v-if="fichero.musica_autor === 1")
									span.fa.fa-gift(title="No contiene fonográmas protegidos por derechos de autor" style="font-size:2em;margin: 5px;vertical-align:middle;" v-else)
								td(style="cursor:pointer;" @click="verFichero(fichero, 'version')")
									|{{fichero.nombre}}
									br
									span(v-if="fichero.duracion" style="font-weight:bold;" :class="(tarea.duracion < fichero.duracion) ? 'text-danger' : 'text-success'")
										span.text-info Duración real: {{fichero.duracion | round(2)}} seg
								td.text-right
									button.btn-sm.btn-danger(v-if="tarea.fase === 'pteProduccion' && esUltima && (tarea.esAgente || permisos.produccion_eliminarProducidos)" @click="eliminaFicheroVersion(fichero)")
										span.fa.fa-trash
									button.btn.btn-sm.btn-warning(title="Subir al XFrame" v-if="tarea.fase === 'finalizada' && !fichero.xframe_num" @click="subirXFrame(fichero)")
										span.fa.fa-upload
									.badge.badge-danger.p-2(style="font-size:1em;" v-if="fichero.xframe_num")
										|{{fichero.xframe_num}}
	selecciona-locutor(v-if="locutorActual" :tarea="tarea" :etiqueta="locutorActual" @cerrar="locutorActual = null" @seleccion="setLocutor($event)")
	rechazo-tarea(v-if="rechazaTarea" :tarea="tarea" :version="versionActual" @cerrar="rechazaTarea = false" @nueva="nuevaVersion($event)")
	editando-tarea(@actualizar="emiteActualizar($event)" :tarea="tarea" v-if="editarTarea" @cerrar="cierraEditorTarea()")
	editando-produccion(@actualizar="emiteActualizar()" :idproduccion="idproduccion" v-if="idproduccion" @cerrar="idproduccion = null")
	reproductor(:fichero="previsualizaFichero" v-if="previsualizaFichero" @cerrar="previsualizaFichero = null")
	historial(@cerrar="verHistorial = false" :idtarea="verHistorial" v-if="verHistorial")
	listado-versiones(:tarea="tarea" :actual="versionActual" v-if="listadoVersiones" @cambia-version="setVersion($event)")
</template>


<script>

import Comentarios from './comentarios'
import EditorTexto from './editor-texto'
import VisualizaTexto from './visualiza-texto'
import SeleccionaLocutor from './seleccion-locutor'
import RechazoTarea from './rechazo-tarea'
import EditandoTarea from './editando-tarea'
import EditandoProduccion from './editando-produccion'
import Reproductor from './reproductor'
import ListadoVersiones from './listado-versiones'
import Historial from './historial'
import Cronometro from './cronometro'
import TarjetaLocutor from './componentes/tarjeta-locutor'
import API from '../../services/api'
import { mapGetters } from 'vuex'

export default {
	name: 'vista-tarea',
	props: ['idtarea', 'focoactivo'],
	components: {
		'comentarios': Comentarios,
		'editor-texto': EditorTexto,
		'visualiza-texto': VisualizaTexto,
		'selecciona-locutor': SeleccionaLocutor,
		'rechazo-tarea': RechazoTarea,
		'editando-tarea': EditandoTarea,
		'editando-produccion': EditandoProduccion,
		'reproductor': Reproductor,
		'historial': Historial,
		'listado-versiones': ListadoVersiones,
		'tarjeta-locutor': TarjetaLocutor,
		'cronometro': Cronometro
	},
	data: function () {
		return {
			tarea: null,
			error: null,
			editarTarea: false,
			mostrarAnotacionesProduccion: false,
			mostrarAnotacionesTarea: false,
			mostrarRechazo: true,
			versionActual: null,
			versionAnterior: null,
			locutorActual: null,
			rechazaTarea: false,
			idproduccion: null,
			previsualizaFichero: null,
			verHistorial: false,
			listadoVersiones: false,
			atajos: {
				ctrl: false
			}
		}
	},

	created () {
		// Buscamos la tarea
		this.getTarea()
	},

	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		}),
		esTareaValida () {
			if (this.tarea.fase === 'finalizada') {
				return true
			}
			return (this.tarea.duracion && this.tarea.fecha_inicio && this.tarea.fecha_fin)
		},
		tituloFase () {
			switch (this.tarea.fase) {
			case 'pteIdea':
				return 'Pendiente de creatividad'
			case 'pteAprobarIdea':
				return 'Pendiente de aprobar texto'
			case 'pteProduccion':
				return 'Pendiente de producción'
			case 'pteAprobarProduccion':
				return 'Pendiente de aprobar producción'
			case 'finalizada':
				return 'Producción finalizada'
			case 'cancelada':
				return 'Producción cancelada'
			}

			return 'Fase desconocida'
		},
		txtSiguienteFase () {
			switch (this.tarea.fase) {
			case 'pteIdea':
				return 'Creatividad terminada'
			case 'pteAprobarIdea':
				return 'Aprobar creatividad'
			case 'pteProduccion':
				return 'Producción terminada'
			case 'pteAprobarProduccion':
				return 'Aprobar producción'
			}

			return this.tarea.fase
		},

		iconoSiguienteFase () {
			switch (this.tarea.fase) {
			case 'pteIdea':
				return 'fa fa-lightbulb-o'
			case 'pteAprobarIdea':
				return 'fa fa-check'
			case 'pteProduccion':
				return 'fa fa-flag-checkered'
			case 'pteAprobarProduccion':
				return 'fa fa-thumbs-up'
			}

			return this.tarea.fase
		},
		esUltima () {
			return this.versionActual.ultima_version.ultima
		},

		textoPlano () {
			let txt = ''

			for (let i = 0; i < this.versionActual.textos.length; i++) {
				const t = this.versionActual.textos[i]
				txt += t.tipo.toUpperCase() + t.numero + ': ' + t.texto + '\n\n-------\n\n'
			}

			return txt
		}
	},

	methods: {
		cerrar () {
			this.$emit('cerrar')
		},

		editarProduccion () {
			this.idproduccion = this.tarea.produccion.ID_produccion
		},

		getTarea () {
			// Examinamos la tarea
			API.getTarea(this.idtarea)
				.then(res => {
					this.tarea = res.data.tarea
					this.versionActual = this.tarea.versiones.slice(-1).pop()

					if (this.tarea.versiones.length > 1) {
						this.versionAnterior = this.tarea.versiones[this.tarea.versiones.length - 2]
					} else {
						this.versionAnterior = null
					}
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		cierraEditorTarea () {
			this.editarTarea = false
			this.getTarea()
		},

		setVersion (datos) {
			this.versionActual = datos.actual
			this.versionAnterior = datos.anterior
			this.listadoVersiones = false
		},

		copiarTexto () {
			const el = document.createElement('pre')
			document.body.appendChild(el)
			el.textContent = this.textoPlano.toString()
			const selection = document.getSelection()
			const range = document.createRange()
			range.selectNode(el)
			selection.removeAllRanges()
			selection.addRange(range)
			document.execCommand('copy')
			selection.removeAllRanges()
			document.body.removeChild(el)
			this.$store.commit('alertas/alert', {
				titulo: 'Texto copiado',
				mensaje: `Se ha copiado el texto en formato plano.
				Pégalo en cualquier edito de texto o de correo electrónico`
			})
		},

		setLocutor (locutor) {
			if (!this.locutorActual) {
				return
			}

			// Veamos si ese locutor ya está asignado
			for (let i = 0; i < this.versionActual.locutores.length; i++) {
				if (this.versionActual.locutores[i].info && this.versionActual.locutores[i].info.ID_locutor === locutor.ID_locutor) {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: 'Este locutor ya está asignado'
					})
					return
				}
			}

			const datos = {
				ID_version: this.versionActual.ID_version,
				titulo: this.locutorActual,
				ID_locutor: locutor.ID_locutor
			}

			API.asignaLocutor(datos)
				.then(res => {
					this.versionActual = res.data.version
					this.locutorActual = null
					this.emiteActualizar()
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		quitaLocutor (loc) {
			const datos = {
				ID_version: this.versionActual.ID_version,
				titulo: loc,
				ID_locutor: null
			}

			API.asignaLocutor(datos)
				.then(res => {
					this.versionActual = res.data.version
					this.locutorActual = null
					this.emiteActualizar()
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		setDuracionEstimada (ev) {
			API.setTiempoEstimado(this.versionActual.ID_version, ev)
				.then(res => {
					this.getTarea()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		nuevoFichero (tipo) {
			if (tipo !== 'final') {
				this.nuevoFicheroFase2(tipo, 0)
			} else {
				this.$store.commit('alertas/confirm', {
					titulo: 'Derechos de autor',
					mensaje: `<b>Importante</b>
					Es necesario que especifiques si el o los ficheros que vas a adjuntar contienen música protegida por derechos de autor.
					<b>¿Tienen derechos de autor?</b>`,
					buttons: [
						{
							titulo: 'Sí',
							clase: 'btn btn-sm btn-primary',
							icono: 'fa fa-check',
							valor: 1
						},
						{
							titulo: 'No',
							clase: 'btn btn-sm btn-danger',
							icono: 'fa fa-ban',
							valor: 0
						}
					],
					callback: tieneDerechos => {
						this.nuevoFicheroFase2(tipo, tieneDerechos)
					}
				})
			}
		},

		nuevoFicheroFase2 (tipo, derechos) {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.style.display = 'none'
			inp.multiple = true
			inp.accept = '.mp3,audio/mpeg'

			inp.addEventListener('change', (ev) => {
				const form = new FormData()
				form.append('ID_tarea', this.tarea.ID_tarea)
				form.append('ID_version', this.versionActual.ID_version)
				form.append('tipo', tipo)
				form.append('musica_autor', derechos)

				for (let i = 0; i < inp.files.length; i++) {
					form.append('fichero[]', inp.files[i])
				}

				API.tareaAddFicheros(form)
					.then(res => {
						this.tarea = res.data.tarea
						this.versionActual = this.tarea.versiones.slice(-1).pop()
						this.emiteActualizar()
					})
					.catch(e => {
						this.$store.commit('alertas/nueva', {
							titulo: 'Error',
							mensaje: e.response.data.error
						})
					})
			})

			document.body.appendChild(inp)

			inp.click()
		},
		eliminaFichero (fichero) {
			const doEliminar = () => {
				const datos = {
					ID_tarea: this.tarea.ID_tarea,
					ID_fichero: fichero.ID_fichero
				}

				API.tareaDelFichero(datos)
					.then(res => {
						this.tarea = res.data.tarea
						this.versionActual = this.tarea.versiones.slice(-1).pop()
						this.emiteActualizar()
					})
					.catch(e => {
						this.$store.commit('alertas/nueva', {
							titulo: 'Error',
							mensaje: e.response.data.error
						})
					})
			}

			this.$store.commit('alertas/nueva', {
				titulo: 'Confirmación',
				mensaje: '¿Quieres eliminar el fichero \'' + fichero.nombre + '\'?\n\nEsta acción no podrá deshacerse',
				callback: (acepta) => {
					if (acepta) {
						doEliminar()
					}
				},
				buttons: [
					{
						titulo: 'Cancelar',
						clase: 'btn btn-sm btn-danger',
						valor: false,
						icono: 'fa fa-ban'
					},
					{
						titulo: 'Aceptar',
						clase: 'btn btn-sm btn-primary',
						vaor: true,
						icono: 'fa fa-check'
					}
				]
			})
		},

		eliminaFicheroVersion (fichero) {
			const doEliminar = () => {
				const datos = {
					ID_version: this.versionActual.ID_version,
					ID_fichero: fichero.ID_fichero
				}

				API.delFicheroVersion(datos)
					.then(res => {
						this.versionActual = res.data.version
						this.emiteActualizar()
					})
					.catch(e => {
						this.$store.commit('alertas/nueva', {
							titulo: 'Error',
							mensaje: e.response.data.error
						})
					})
			}

			this.$store.commit('alertas/nueva', {
				titulo: 'Confirmación',
				mensaje: '¿Quieres eliminar el fichero \'' + fichero.nombre + '\'?\n\nEsta acción no podrá deshacerse',
				callback: (acepta) => {
					if (acepta) {
						doEliminar()
					}
				},
				buttons: [
					{
						titulo: 'Cancelar',
						clase: 'btn btn-sm btn-danger',
						valor: false,
						icono: 'fa fa-ban'
					},
					{
						titulo: 'Aceptar',
						clase: 'btn btn-sm btn-primary',
						valor: true,
						icono: 'fa fa-check'
					}
				]
			})
		},

		// La fase previa a ésta es: pteTexto
		textoTerminado () {
			if (this.versionActual.textos.length === 0) {
				this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: 'No has escrito nada de texto'
				})
				return
			}

			for (let i = 0; i < this.versionActual.textos.length; i++) {
				if (this.versionActual.textos[i].texto.trim().length === 0) {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: 'El texto número ' + (i + 1) + ' no tiene nada escrito. No se admiten textos vacíos'
					})
					return
				}
			}

			this.tarea.fase = 'pteApruebaTexto'
		},

		// la fase previa a ésta es: pteApruebaTexto
		textoAprobado () {
			this.tarea.fase = 'pteProduccion'
		},

		// La fase previa a esta es: pteProduccion
		produccionTerminada () {
			// Comprobamos que todos los textos estén grabados
			for (let i = 0; i < this.versionActual.textos.length; i++) {
				if (!this.versionActual.textos[i].grabado) {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'El texto: ' + (i + 1) + ' no está grabado'
					})
					return
				}
			}

			this.tarea.fase = 'pteApruebaProduccion'
		},

		// La fase previa a ésta es: pteApruebaProduccion
		produccionRechazada () {
			this.tarea.fase = 'pteProduccion'
		},

		// La fase previa a ésta es: pteApruebaProduccion
		produccionAprobada () {
			this.tarea.fase = 'finalizada'
		},

		checkDuraciones (cb) {
			if (this.tarea.fase === 'pteAprobarProduccion') {
				const ficherosPasados = []
				console.log(this.$options.filters)
				for (let i = 0; i < this.versionActual.ficheros.length; i++) {
					if (this.versionActual.ficheros[i].duracion > this.tarea.duracion) {
						const exceso = this.versionActual.ficheros[i].duracion - this.tarea.duracion

						if (exceso > 0.5) {
							ficherosPasados.push({
								titulo: this.versionActual.ficheros[i].nombre,
								duracion: this.$options.filters.round(this.versionActual.ficheros[i].duracion, 2),
								exceso: this.$options.filters.round(exceso, 2)
							})
						}
					}
				}

				if (ficherosPasados.length > 0) {
					let texto = ficherosPasados.reduce((ant, fichero) => {
						ant = ant + `<li>${fichero.titulo}:
											<ul>
												<li>Duración: ${fichero.duracion} seg.</li>
												<li>Excede: ${fichero.exceso} seg.</li>
											</ul>
									</li>`
						return ant
					}, '')
					texto = '<ul>' + texto + '</ul>'

					this.$store.commit('alertas/confirm', {
						titulo: 'Ficheros fuera de duración detectados',
						mensaje: `Se han detectado ficheros producidos que exceden el tiempo contratado (<b>${this.tarea.duracion} seg.</b>). Si continuas y apruebas <b>se generará una incidencia.</b>
						Estos son los ficheros:
						${texto}`,
						callback: acepta => {
							if (acepta) {
								cb()
							}
						}
					})
				} else {
					cb()
				}
			} else {
				cb()
			}
		},
		siguienteFase () {
			this.checkDuraciones(() => {
				this.$store.commit('alertas/confirm', {
					titulo: 'Confirmación',
					mensaje: '¿Estás seguro de que quieres dar esta fase por completada?',
					callback: (acepta) => {
						if (acepta) {
							const datos = {
								ID_version: this.versionActual.ID_version
							}

							API.setSiguienteFase(datos)
								.then(res => {
									this.versionActual = res.data.version
									this.emiteActualizar()
								})
								.catch(e => {
									const msj = e.response.data.error || 'Error pasando a la siguiente fase'
									this.$store.commit('alertas/nueva', {
										titulo: 'Error',
										mensaje: msj
									})
								})
						}
					}
				})
			})
		},

		cancelarTarea () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Cancelar tarea',
				mensaje: `Si cancelas esta tarea se expulsará del proceso de producción`,
				callback: (acepta) => {
					if (acepta) {
						API.cancelarTarea(this.tarea.ID_tarea)
							.then(res => {
								this.getTarea()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},

		verFichero (fichero, tipo) {
			this.previsualizaFichero = {
				fichero: fichero,
				tipo: tipo
			}
		},
		rechazar () {
			this.rechazaTarea = true
		},
		subirXFrame (fichero) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Subir al XFrame',
				mensaje: '¿Quieres subir este fichero al XFrame?\nEsto generará un nuevo número de XFrame',
				callback: (acepta) => {
					if (!acepta) {
						return
					}

					const datos = {
						ID_fichero: fichero.ID_fichero,
						ID_version: this.versionActual.ID_version
					}

					API.setSubirXFrame(datos)
						.then(res => {
							this.$store.commit('alertas/alert', {
								titulo: 'Fichero subido',
								mensaje: 'Se ha subido el fichero y se le ha asignado el número ' + res.data.fichero.xframe_num
							})
							this.getTarea()
						})
						.catch(e => {
							this.$store.commit('alertas/alert', {
								titulo: 'Error',
								mensaje: e.response.data.error
							})
						})
				}
			})
		},

		nuevaVersion (data) {
			this.versionActual = data
			this.emiteActualizar()
		},

		setTeleprompter () {
			const datos = {
				ID_version: this.versionActual.ID_version
			}

			API.setTeleprompter(datos)
				.then(res => {
					this.getTarea()
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		emiteActualizar (eliminada) {
			if (eliminada) {
				this.$emit('actualizar')
				this.cerrar()
			} else {
				this.getTarea()
				this.$emit('actualizar')
			}
		}
	}
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/produccion.vue